import { SVGProps } from 'react';

const Pipelines = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.6 16.5C9.14052 16.5 11.2 14.4853 11.2 12C11.2 9.51471 9.14052 7.49999 6.60001 7.49999C4.05949 7.49999 2 9.51471 2 12C2 14.4853 4.05949 16.5 6.6 16.5ZM6.6 16.5L14.15 16.5L14.15 22L22 12L14.15 2L14.15 7.49999L12.35 7.49999" stroke="currentcolor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default Pipelines;
